/**
 * Anonymous (no-login) warm-intro invite token store.
 *
 * For Lite-ATS pre-screening warm-intro interviews the candidate has no Cevee
 * account; the interview is authenticated via the invite token alone. We stash
 * that token in sessionStorage keyed by the session id so the interview room
 * (a separate route) can authenticate REST + WS calls without a JWT.
 *
 * sessionStorage (not localStorage): the token is single-session-scoped and
 * should not survive a browser restart.
 */
const KEY = (sessionId: string) => `cevee_anon_invite:${sessionId}`;

export function setAnonInviteToken(sessionId: string, token: string): void {
  try {
    sessionStorage.setItem(KEY(sessionId), token);
  } catch {
    /* sessionStorage unavailable (private mode quota etc.) -- non-fatal */
  }
}

export function getAnonInviteToken(sessionId: string): string | null {
  try {
    return sessionStorage.getItem(KEY(sessionId));
  } catch {
    return null;
  }
}

export function clearAnonInviteToken(sessionId: string): void {
  try {
    sessionStorage.removeItem(KEY(sessionId));
  } catch {
    /* non-fatal */
  }
}
